import styled from 'styled-components'

export const Select = styled.select`
  height: 36px;
  width: 218px;
  border-radius: 2px;
`
